// extracted by mini-css-extract-plugin
module.exports = {"footer":"App_footer__29Fsv","container":"App_container__1MQN3"};